<template>
  <div class="RwvPost">
    <div class="banner" v-bind:class="{'dark-banner': !isLightTheme}">
      <div class="inner-section">
        <h1>{{post.title}}</h1>
        <h6>{{post.subtitle}}</h6>
        <RwvPostMeta
          :post="post"
          :actions="true"
          :isBook="isBook"
          :isLightTheme="isLightTheme"
          :isAuthenticated="isAuthenticated"
          :preview="preview">
        </RwvPostMeta>
        <i class="inner-section" v-if="!post.published && isBook">
          Buch ist nicht veröffentlicht
        </i>
        <i class="inner-section" v-if="!post.published && !isBook">
          Artikel ist nicht veröffentlicht
        </i>
      </div>
    </div>


    <b-container fluid class="outer-section special-section">
      <!-- If -->
      <b-row v-if="isBook || (post.image && post.image.showInPost && post.image.data)">

        <b-col md="3" xs="12" cols="12" class="dk-product" v-if="post.productSlug">
        </b-col>

        <!-- If Article -->
        <b-col md="6" xs="6" cols="12" class="img-action-button-container img-action-button-container-article" v-if="post.image && post.image.showInPost && post.image.data">
          <img class="preview-image" :src="post.image.data" :title="post.image.description" :alt="post.image.description"/>
          <template>
            <rwv-post-actions
              :post="post"
              :isAuthenticated="isAuthenticated"
              :preview="preview"
              :isLightTheme="true"
              :isBook="isBook"
              class="actions"
            ></rwv-post-actions>
          </template>
        </b-col>

        <!-- Else Book-->
        <b-col md="6" xs="6" cols="12" class="img-action-button-container img-action-button-container-book" v-else-if="isBook">
          <template>
            <rwv-post-actions
              :post="post"
              :isAuthenticated="isAuthenticated"
              :preview="preview"
              :isLightTheme="true"
              :isBook="isBook"
              class="actions"
            ></rwv-post-actions>
          </template>
        </b-col>

        <!-- If Book-->
        <b-col md="3" xs="6" cols="12" class="dk-product" v-if="post.productSlug">
          <RwvProductCard :isAuthenticated="isAuthenticated" :product="post.linkedProduct" :preview="$attrs.preview"/>
        </b-col>
      </b-row>

      <!-- Else -->
      <b-row v-else>
        <b-col md="4" xs="3" cols="1">
        </b-col>
        <b-col md="4" xs="6" cols="10" class="dk-product">
          <RwvProductCard :isAuthenticated="isAuthenticated" :product="post.linkedProduct" :preview="$attrs.preview"/>
        </b-col>
        <b-col md="4" xs="3" cols="1">
        </b-col>
      </b-row>
    </b-container>

    <!-- <b-container fluid class="outer-section">

      <b-row v-if="isBook || (post.image && post.image.showInPost && post.image.data)">

        <b-col md="6" xs="6" cols="12" class="img-action-button-container" v-if="post.image && post.image.showInPost && post.image.data">
          <img class="preview-image" :src="post.image.data" :title="post.image.description" :alt="post.image.description"/>
          <template v-if="isBook">
            <rwv-post-actions
              :post="post"
              :isAuthenticated="isAuthenticated"
              :preview="preview"
              :isLightTheme="true"
              :isBook="isBook"
              class="actions"
            ></rwv-post-actions>
          </template>
        </b-col>

        <b-col md="6" xs="6" cols="12" class="img-action-button-container" v-else-if="isBook">
          <template>
            <rwv-post-actions
              :post="post"
              :isAuthenticated="isAuthenticated"
              :preview="preview"
              :isLightTheme="true"
              :isBook="isBook"
              class="actions"
            ></rwv-post-actions>
          </template>
        </b-col>
        <b-col md="6" xs="6" cols="12" class="dk-product" v-if="post.productSlug">
          <RwvProductCard :isAuthenticated="isAuthenticated" :product="post.linkedProduct"/>
        </b-col>
      </b-row>

      <b-row v-else>
        <b-col md="4" xs="3" cols="1">
        </b-col>
        <b-col md="4" xs="6" cols="10" class="dk-product">
          <RwvProductCard :isAuthenticated="isAuthenticated" :product="post.linkedProduct"/>
        </b-col>
        <b-col md="4" xs="3" cols="1">
        </b-col>
      </b-row>
    </b-container> -->

    <div class="inner-section">
      <RwvContent
        v-for="(content, index) in contentWithAds"
        :key="index"
        :content="content"
        :index="index">
      </RwvContent>
      <!-- ToDo: Put into Component with share Options -->

      <div class="variants" v-if="isFooterMeta">
        <b-badge
          pill
          variant="warning"
          v-for="(variant, index) in post.variants"
          :key="index">
          {{ variant.model.manufacturer.name + " " + variant.model.name  + " " + variant.year + " (" + variant.variant + ")"}}
        </b-badge>
      </div>
      <RwvTags v-if="isFooterMeta" :tags="post.tags"></RwvTags>

      <b-container>
        <b-row>
          <b-col v-if="post.productSlug">
            <RwvProductCard :isAuthenticated="isAuthenticated" :product="post.linkedProduct" :preview="$attrs.preview"/>
          </b-col>
          <b-col v-if="post.secondProductSlug">
            <RwvProductCard :isAuthenticated="isAuthenticated" :product="post.secondLinkedProduct" :preview="$attrs.preview"/>
          </b-col>
          <b-col class="linked-article" v-if="post.articleSlug">
            <RwvArticleCard :isAuthenticated="isAuthenticated" :article="post.linkedArticle"/>
          </b-col>
          <b-col class="linked-book" v-if="post.bookSlug">
            <RwvBookCard :isAuthenticated="isAuthenticated" :book="post.linkedBook"/>
          </b-col>
        </b-row>
      </b-container>
      <!-- <p>
        <i v-for="isbn in post.isbns" :key="isbn.isbn" class="isbn">
          <span v-if="isbn.isbn && isbn.title">{{ isbn.title }}: {{ isbn.isbn }};</span>
        </i>
      </p> -->
      <!-- <b-button-group>
        <b-button
          variant="outline-secondary"
          class="nextLastButton last"
          v-on:click="last"
          v-b-tooltip.hover
          title="Einen Artikel zurück">

          <i class="material-icons">keyboard_arrow_left</i>
        </b-button>

        <b-button
          variant="outline-secondary"
          class="nextLastButton next"
          v-on:click="next"
          v-b-tooltip.hover
          title="Einen Artikel weiter">

          <i class="material-icons">keyboard_arrow_right</i>
        </b-button>
      </b-button-group> -->
    </div>
  </div>
</template>

<script>
import RwvPostMeta from "@/components/Posts/PostMeta";
import RwvPostActions from "@/components/Posts/PostActions";
import RwvContent from "@/components/Contents/Content";
import RwvTags from "@/components/Tags";
import RwvProductCard from "@/components/Cards/ProductCard";
import RwvArticleCard from "@/components/Cards/ArticleCard";
import RwvBookCard from "@/components/Cards/BookCard";
import { mapGetters } from "vuex";

export default {
  name: "RwvPost",
  props: {
    post: {
      type: Object,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    isBook: {
      type: Boolean,
      default: false
    },
    isLightTheme: {
      type: Boolean,
      default: false
    },
    isFooterMeta: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RwvPostMeta,
    RwvPostActions,
    RwvContent,
    RwvProductCard,
    RwvArticleCard,
    RwvBookCard,
    RwvTags
  },
  computed: {
    contentWithAds() {
      var contentCount = this.post.content.length
      var content = JSON.parse(JSON.stringify(this.post.content))

      // in-post
      content.unshift({
        type: "Ad",
        data: {
          ad_client: "ca-pub-0281378002600422",
          ad_slot: "2838246407"
        }
      })
      // in-post-bottom
      content.push({
        type: "Ad",
        data: {
          ad_client: "ca-pub-0281378002600422",
          ad_slot: "9681365664"
        }
      })

      if (contentCount >= 4) {
        // Little Content: Start and End

        var index =  Math.round((contentCount/2)) + 1

        //in-post-middle
        content.splice(index, 0, {
          type: "Ad",
          data: {
            ad_client: "ca-pub-0281378002600422",
            ad_slot: "8560867447"
          }
        });
      }

      return content
    },
    ...mapGetters(["isAuthenticated"])
  },
  watch: {
    post: {
      handler() {
        console.log("post did change")
        this.$forceUpdate();
      },
      deep: true
    }
  },
  methods: {
    last() {

    },
    next() {

    },
  },
};
</script>

<style lang="scss">
.RwvPost {
  .dk-product {
    float: right;
  }
  .outer-section {
    .img-action-button-container {
      max-width: 100%;
      text-align: center;
      max-height: 600px;
      width: auto;
      margin: 20px auto;

      .actions {
        margin-left: 1em;
      }
    }
    .img-action-button-container-book {
      img {
        max-width: 195px;
      }
    }
  }
}

.isbn {
  font-size: 0.7em;
}

.edit.section {
  .RwvImageCropper {
    img {
      max-width: 80%;
      max-height: 400px;
      margin: auto;
      display: block;
      margin-bottom: 10px;
    }
  }
  .cropper {
    max-height: 26.875rem;
  }
  .form-check-label {
    margin-left: 1.25em;
  }
  .form-check-input {
    margin-left: 0;
  }
  .deactivated {
    opacity: 0.9;
  }
  form {
    margin-bottom: 3rem;
  }
  .tabs {
    min-height: 550px;
  }
}

@media screen and (min-width: $screen-md-min) {
  .splitView {
    clear: both;
    .edit.section, .RwvPost {
      width: 50%;
      float:left;
    }
    .RwvPost {
      border-left: 1px solid rgba(0,0,0,0.35);
    }
    .RwvImageCropper {
      width: 300px;
    }
    .col-md-6 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}
</style>
